import { render, staticRenderFns } from "./pointsDetail.vue?vue&type=template&id=197cd48d&"
import script from "./pointsDetail.vue?vue&type=script&lang=js&"
export * from "./pointsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports